<template>
    <form action="" @submit.prevent="login">
        <div class="row contact-form-block" v-if="show_form">
            <div class="col-6">
                <div class="contact-input-wrapper">
                    <input 
                        type="text"
                        class="contact-form-input" 
                        id="id_username" 
                        name="username" 
                        v-model="username"
                        required />
                    <label>Usuário</label>
                </div>
            </div>
            <div class="col-6">
                <div class="contact-input-wrapper">
                    <input 
                        type="password"
                        class="contact-form-input" 
                        id="id_password" 
                        name="password" 
                        v-model="password"
                        required />
                    <label>Senha</label>
                </div>
            </div>
            <div class="col-12">
                <input class="contact-submit-btn" type="submit" value="Enviar">
            </div>
        </div>
    </form>
</template>

<script>
import api from '@/api'

export default {
    name: 'Login',
    props:['show_form'],
    data() {
        return {
            username: null,
            password: null,
        }
    },
    methods:{
        async login(){
            const response = await api.post('token/', {
                username: this.username,
                password: this.password,
            })

            if (response.ok) {
                this.$root.$emit('gazetaweb:login', response.data.token)
                localStorage.setItem('token', response.data.token)
            }
        },
        checkLogin() {
            const token = localStorage.getItem('token')
            if (token) {
                this.$root.$emit('gazetaweb:login', token)
            }
        }
    },
    mounted(){
        this.checkLogin()
    }
}
</script>